export class Resizer {
    public static observeHeight(elementToWatchFn: () => HTMLElement, elementToUpdateFn: () => HTMLElement): void {
        setInterval(() => {
            const elementToWatch = elementToWatchFn();

            if (elementToWatch) {
                const height = elementToWatch.getBoundingClientRect().height;
                const elementToUpdate = elementToUpdateFn();

                if (elementToUpdate) {
                    elementToUpdate.style.minHeight = height + 'px';
                }
            }
        }, 60);
    }
}
